module.exports = __webpack_public_path__ + "assets/0876ed9d8d684d6b64a045aec617fce9.mp3";